import axios from 'axios'
import settings from '../settings'

export default (app, inject) => {
    axios.defaults.baseURL = settings.API_URL

    // console.log(settings)

    if (settings.AUTH_TOKEN) {
        axios.defaults.headers.common[
            'Authorization'
        ] = `Bearer ${settings.AUTH_TOKEN}`
    }

    if (settings.CSRF_TOKEN) {
        axios.defaults.headers.common['X-CSRF-TOKEN'] = `${settings.CSRF_TOKEN}`
    } else {
        // console.error(
        //     'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token'
        // )
    }

    inject('axios', axios)
}
